import { getBaseUrl } from '@/redux/modules/config';
import { getCanonicalURL } from '@/redux/modules/landingPage';
import { useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useGetSearchPageCanonicalUrl = () => {
    const { pathname, search } = useLocation();
    const pathAndQuery = pathname + search;

    const baseUrl = useAppSelector(getBaseUrl);
    const canonicalURL = useAppSelector(getCanonicalURL);

    return useMemo(() => {
        const canonicalURLMeta = canonicalURL ? canonicalURL : pathAndQuery;

        return `${baseUrl}${canonicalURLMeta}`;
    }, [baseUrl, canonicalURL, pathAndQuery]);
};
